module.exports = __webpack_public_path__ + "img/imgUser.3cec0a16.jpeg";